import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { inject } from '@angular/core';
import { LoadingService } from '../services/loading.service';

export const SkipLoading = new HttpContextToken<boolean>(() => false);

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
    const loadingService = inject(LoadingService);

    if (req.context.get(SkipLoading)) {
        return next(req);
    }

    loadingService.onRequestStarting();

    return next(req).pipe(
        finalize(() => {
            loadingService.onRequestEnded();
        }),
    );
};
